import React, { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import useUserInfo from './hooks/useUserInfo';
import Navbar from './components/Navbar';
import Editor from './components/Editor';
import { useParams } from 'react-router-dom';
import { Alert, Box, useTheme } from '@mui/material';

const NotePage = () => {
    const apiUrl = process.env.REACT_APP_BACKEND_API;
    const userInfo = useUserInfo(apiUrl);
    const { noteID } = useParams();
    const [message, setMessage] = useState('');
    const theme = useTheme();

    useEffect(() => {
        const handleSaveShortcut = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 's') {
                e.preventDefault();
                setMessage('Notes are saved automatically.');
            }
        };
        window.addEventListener('keydown', handleSaveShortcut);

        return () => {
            window.removeEventListener('keydown', handleSaveShortcut);
        };
    }, []);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage('');
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [message]);

    if (userInfo.is_authenticated === false) {
        window.location.href = "/signin";
        return null;
      }

    return (
        <Box>
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center',
                padding: theme.spacing(1, 2),
            }}>
                <Navbar />
            </Box>
            
            <Container
                sx={{
                    marginTop: theme.spacing(3),
                    maxWidth: '800px',
                    paddingBottom: theme.spacing(100),
                    paddingX: theme.spacing(3),
                }}
            >
                {message && (
                    <Alert 
                        severity="success" 
                        sx={{ 
                            position: 'fixed',
                            top: theme.spacing(2.5),
                            right: theme.spacing(2.5),
                            margin: '0 auto',
                            zIndex: 1000,
                            borderRadius: '6px',
                        }}
                    >
                        {message}
                    </Alert>
                )}
                <Editor noteID={noteID} />
            </Container>
        </Box>
    );
};

export default NotePage;

